import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bloco-empresas',
  templateUrl: './bloco-empresas.component.html',
  styleUrls: ['./bloco-empresas.component.scss'],
  standalone: true,
})
export class BlocoEmpresasComponent {
  @Output() closeEmpresas = new EventEmitter<void>();

  constructor(private router: Router) {}

  navigateTo(tipo: 'salvas' | 'novo' | 'minha-carteira' | 'tarefas'): void {
    this.router.navigate([`/empresas/${tipo}`]);
    this.closeEmpresas.emit();
  }
}
